// extracted by mini-css-extract-plugin
module.exports = {"footer__build-version":"Footer_footer__build-version__T8pzA"};